/**
 * created on: 2019.04.01
 * 广电广电文稿-电视稿-左侧导航
 */
"use strict";
angular.module('televisionLeftModule', [])
    .controller('televisionLeftCtrl', ['$scope', '$timeout', '$state', '$stateParams', '$q', 'trsHttpService', '$filter', 'editingMediatype', 'editingCenterService', '$location', function($scope, $timeout, $state, $stateParams, $q, trsHttpService, $filter, editingMediatype, editingCenterService, $location) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                isdownPicShow: false,
                selectedSite: '',
                manuscriptTypes: [{
                    name: '待编',
                    value: 'waitcompiled',
                }, {
                    name: '待审',
                    value: 'pending',
                }, {
                    name: '已签发',
                    value: 'signed'
                }],
                selectedManuscript: {
                    name: '待编',
                    value: 'waitcompiled',
                },
                path: $location.path().split('/'),
            };

            $scope.data = {
                sites: []
            };

            initDropDownListBlur();
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            initTvStation().then(function() {
                return initTelevisionStation();
            }).then(function() {
                return initPlatform();
            });
        }

        /**
         * [initTvStation 初始化电视站点]
         * @return {[type]} [description]
         */
        function initTvStation() {
            var defer = $q.defer();
            editingCenterService.querySitesByMediaType(editingMediatype.television).then(function(data) {
                if (angular.isUndefined(data)) {
                    defer.reject();
                } else {
                    $scope.data.sites = data.DATA;
                    defer.resolve();
                }
                //$scope.status.isDownImgShow = data.DATA.length > 1 ? true : false;
                // var filteredSite = $filter('filterBy')(data.DATA, ['SITEID'], $scope.websiteId);
                // $timeout(function() {
                //     $scope.status.selectedSite = filteredSite.length > 0 ? filteredSite[0] : data.DATA[0];
                // });
            });
            return defer.promise;
        }

        /**
         * [initTelevisionStation 记忆路由站点参数]
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function initTelevisionStation(data) {
            var defer = $q.defer();
            var televisionSiteId = $state.params.siteid;
            var platform = $scope.status.path.length > 4 ? $scope.status.path[4] : 'waitcompiled';
            if (angular.isDefined(televisionSiteId)) {
                var filteredSite = $filter('filterBy')($scope.data.sites, ['SITEID'], televisionSiteId);
                var filterPlatform = $filter('filterBy')($scope.status.manuscriptTypes, ['value'], platform);
                $scope.status.selectedSite = filteredSite[0];
                $scope.status.selectedManuscript = filterPlatform[0];
                // $scope.status.selectedManuscript = filteredDoctype[0];
            } else {
                $scope.status.selectedSite = $scope.data.sites[0];
            }
            defer.resolve();
            return defer.promise;
        }

        /**
         * [initPlatform 选择稿件状态]
         * @param  {[type]} platform [description]
         * @return {[type]}          [description]
         */
        function initPlatform() {
            var platform;
            if ($scope.status.path.length > 4) {
                platform = $scope.status.path[4];
                var routerName = "front.editctr.television." + platform;
            } else {
                var routerName = "front.editctr.television." + $scope.status.selectedManuscript.value;
            }
            $timeout(function() {
                $state.go(routerName, {
                    // doctype: $scope.status.selectedManuscript.value,
                    siteid: $scope.status.selectedSite.SITEID
                });
            }, 500);
        };

        /**
         * [setTelevisionChannel 选择广电频道]
         * @param {[type]} channel [description]
         */
        $scope.setTelevisionChannel = function(site) {
            if ($scope.status.selectedSite === site) return;
            $scope.status.selectedSite = site;
            var routerName = $state.current.name;
            $state.go(routerName, {
                // doctype: $state.params.doctype,
                siteid: $scope.status.selectedSite.SITEID,
            }, { reload: routerName });
        };

        /**
         * [setManuscript 选择稿件平台]
         * @param {[type]} type [description]
         */
        $scope.setManuscript = function(platform) {
            if ($scope.status.selectedManuscript.value == platform.value) return;
            $scope.status.selectedManuscript = platform;
            var routerName = 'front.editctr.television.' + platform.value;
            $state.go(routerName, {
                // doctype: $scope.status.selectedManuscript.value,
                siteid: $scope.status.selectedSite.SITEID,
            }, { reload: routerName });
        };

        /**
         * [initDropDownListBlur description] 初始化下拉菜单失焦事件
         * @return {[type]} [description]
         */
        function initDropDownListBlur() {
            $("html").unbind("click", myBlur).bind("click", myBlur);

            function myBlur($event) {
                var $target = $($event.target);
                if ($target.parents(".content_nav_select").length === 0) {
                    $timeout(function() {
                        $scope.status.isdownPicShow = false;
                    });
                }
            }
            $scope.$on("$destroy", function() {
                $("html").unbind("click", myBlur);
            });
        }

        /**
         * [siteCut description]  根据不同分辨率截取不同长度的名称2
         * @param {[type]} site [description]
         */
        $scope.siteCut = function(site) {
            if (window.screen.width <= '1366') {
                site = $filter('trsLimitTo')(site, '8');
            } else if (window.screen.width <= '1680' && window.screen.width > '1366') {
                site = $filter('trsLimitTo')(site, '10');
            } else if (window.screen.width > '1680') {
                site = $filter('trsLimitTo')(site, '12');
            }
            return site;
        };
    }]);